import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import Strings from '../../../Strings';
import Table3, { columnHelper } from '../../../containers/Table/Table3';
import { DATE_MONTH_DAY_YEAR, TIME_FORMAT_12_UPPERCASE } from '../../../constants';
import { PageHeader } from '../../../components/PageHeader';
import { Button, HEADER_BUTTON_DARK_BLUE } from '../../../components/PageHeader/Button';
import { openModalAction } from '../../../actions/modal';
import { actions } from '../../Kits/redux/actions';
import { CHANGE_KIT_ADMINISTRATIVE_STATUS } from '../../Kits/redux/constants';
import { StateTypes } from '../../../modals/ChangeStateModal';

function KitStatusHistory(props) {
  const [history, setHistory] = React.useState([]);
  const deviceId = props.match.params.deviceId || props.match.params.id;

  React.useEffect(() => {
    getData();
  }, [deviceId]);

  const getData = () => {
    props.getKitStatusHistory(deviceId).then(resp => {
      if (resp?.response) {
        const ret = [];
        resp.response.forEach(e => {
          let statusChanged = '-';
          let old_status = '-';
          let new_status = '-';
          if (e.old_operational_state && e.new_operational_state) {
            statusChanged = Strings.operationalState;
            old_status = e.old_operational_state;
            new_status = e.new_operational_state;
          } else if (e.new_administrative_state && e.old_administrative_state) {
            statusChanged = Strings.administrativeState;
            old_status = e.old_administrative_state;
            new_status = e.new_administrative_state;
          } else if (e.new_usage_state && e.old_usage_state) {
            statusChanged = Strings.usageState;
            old_status = e.old_usage_state;
            new_status = e.new_usage_state;
          }
          ret.push({
            ...e,
            old_status,
            new_status,
            statusChanged,
          });
        });
        setHistory(ret);
      }
    });
  };

  const onStatusChange = () => {
    const data = {
      id: deviceId,
      propertyForApi: 'state',
      action: actions.changeKitAdministrativeState,
      actionType: CHANGE_KIT_ADMINISTRATIVE_STATUS,
      title: Strings.changeDeviceState,
      state: StateTypes.kit.id,
      onSuccess: getData,
    };
    props.changeDeviceStatus(data);
  };

  const columns = React.useMemo(() => [
    columnHelper.accessor('change_time', {
      header: Strings.date,
      cell: info => (info.getValue() ? moment(info.getValue()).format(DATE_MONTH_DAY_YEAR) : '-'),
      size: 120,
    }),
    columnHelper.accessor('change_time', {
      header: Strings.time,
      cell: info => (info.getValue() ? moment(info.getValue()).format(TIME_FORMAT_12_UPPERCASE) : '-'),
      size: 120,
    }),
    columnHelper.accessor('statusChanged', {
      header: Strings.changedStatus,
      cell: info => info.getValue() || '-',
      size: 150,
    }),
    columnHelper.accessor('old_status', {
      header: Strings.oldStatus,
      cell: info => info.getValue() || '-',
      size: 120,
    }),
    columnHelper.accessor('new_status', {
      header: Strings.newStatus,
      cell: info => info.getValue() || '-',
      size: 120,
    }),
    columnHelper.accessor('change_note', {
      header: Strings.note,
      cell: info => info.getValue() || '-',
      size: 200,
    }),
    columnHelper.accessor('valid_until', {
      header: Strings.validUntil,
      cell: info => (info.getValue() ? moment(info.getValue()).format(DATE_MONTH_DAY_YEAR) : '-'),
      size: 120,
    }),
  ], []);

  return (
    <React.Fragment>
      <PageHeader
        left={Strings.KitStatusHistory}
        right={<Button onClick={onStatusChange} class={HEADER_BUTTON_DARK_BLUE} title={Strings.changeDeviceState} />}
      />
      <Table3
        name="device-status-history"
        data={history}
        columns={columns}
      />
    </React.Fragment>
  );
}

KitStatusHistory.propTypes = {
  activeTab: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  getKitStatusHistory: id => dispatch(actions.getKitStatusHistory(id)),
  changeDeviceStatus: data => dispatch(openModalAction('change-state', data)),
});

export default connect(null, mapDispatchToProps)(KitStatusHistory);
